import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import {
  requireProviderTags,
  updateSearchTag,
} from 'store/providers/providerSlice';

import ErrorView from 'components/ErrorView/ErrorView';
import Input from '../../../Input/Input';
import Select from '../../../Select';
import { notifyError } from '../../../Notify/Notify';
import i18n from '../../../../i18n';
import Button from '../../../Button/Button';
import { lightGray, red } from '../../../../utils/style/colors';
import styled from 'styled-components';

const HintBox = styled.div`
  background: ${lightGray};
  padding: 0.5rem;
  border-radius: 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const SearchTagEditor = ({ item, dispatch, tags }) => {
  const [savingData, setSavingData] = useState(false);
  const [skipViewPermissionCheck, setSkipViewPermissionCheck] = useState(
    item.data.skipViewPermissionCheck
  );
  const [applyMyPermissionToItems, setApplyMyPermissionToItems] = useState(
    item.data.applyMyPermissionToItems
  );
  const [applyMinPermissionLevel, setApplyMinPermissionLevel] = useState(
    item.data.applyMinPermissionLevel
  );
  const [selectedAllTagsIDs, setSelectedAllTagIDs] = useState(
    item.data.mandatoryTagIds || []
  );
  const [selectedAtlestOneTagID, setSelectedAtlestOneTagID] = useState(
    item.data.optionalTagIds || []
  );

  const [selectedMandatoryTags, setSelectedMandatoryTags] = useState(
    item.data.mandatoryTags || []
  );
  const [selectedOptionalTags, setSelectedOptionalTags] = useState(
    item.data.optionalTags || []
  );

  const [searchType, setSearchType] = useState('mine');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(requireProviderTags({ providerId: item.data.providerId })).then(
      () => {
        setLoading(false);
      }
    );
  }, []);

  const handleSaveSearchTagOptions = (e) => {
    e.preventDefault();
    setSavingData(true);
    // const newMandatoryTags = $(mandatoryTagsRef.current)
    //   .my_material_chip('data')
    //   .map((tag) => tag.tag);
    // const newOptionalTags = $(optionalTagsRef.current)
    //   .my_material_chip('data')
    //   .map((tag) => tag.tag);

    const newItem = {
      ...item,
      data: {
        ...item.data,
        mandatoryTagIds: selectedAllTagsIDs,
        optionalTagIds: selectedAtlestOneTagID,
        mandatoryTags: selectedMandatoryTags,
        optionalTags: selectedOptionalTags,
        searchType: searchType,
        skipViewPermissionCheck,
        applyMyPermissionToItems,
        applyMinPermissionLevel,
      },
    };

    dispatch(updateSearchTag({ item: newItem.data }))
      .then(() => {
        setSavingData(false);
      })
      .catch((err) => {
        setSavingData(false);
        notifyError(err);
      });
  };
  const tagOptions = Object.values(tags).reduce((acc, tag) => {
    acc.push({
      label: tag.text,
      value: tag.id,
    });
    return acc;
  }, []);

  // const searchOptions = [
  //   {
  //     label: i18n.t('mine', { ns: 'documentManager' }),
  //     value: 'mine',
  //   },
  //   {
  //     label: i18n.t('myReference', { ns: 'documentManager' }),
  //     value: 'myReference',
  //   },
  // ];

  const handleSelectAllTags = (values) => {
    setSelectedAllTagIDs(values.map((option) => option.value));
  };

  const handleSelectAtleastOneTag = (values) => {
    setSelectedAtlestOneTagID(values.map((option) => option.value));
  };

  // const handleSearchOptions = (values) => {
  //   setSearchType(values[0].value);
  // };

  return (
    <div className="modal-content flex-box" style={{ paddingBottom: '0' }}>
      <div
        style={{
          height: 'calc(100% - 50px)',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <div className="border-black border-3 border-solid rounded-md px-4 py-1 mb-5">
          {i18n.t('smartFolderDocumentsHints', { ns: 'documentManager' })}
        </div>
        {loading && (
          <div className="progress">
            <div className="indeterminate" />
          </div>
        )}
        <span className="">
          <form onSubmit={handleSaveSearchTagOptions}>
            <HintBox>
              <div style={{ fontWeight: 'bold', color: red }}>
                {i18n.t('tagConversion', { ns: 'documentManager' })}
              </div>
              <Select
                multiChoice={true}
                label={i18n.t('oldOptionalTags', { ns: 'documentManager' })}
                options={tagOptions}
                values={tagOptions.filter((option) =>
                  selectedOptionalTags.includes(option.label)
                )}
                onChangeValues={(values) =>
                  setSelectedOptionalTags(values.map((option) => option.label))
                }
                containerStyle={{ margin: '0 0.5rem', marginBottom: '0.5rem' }}
              />
              <Select
                multiChoice={true}
                label={i18n.t('oldMandatoryTags', { ns: 'documentManager' })}
                options={tagOptions}
                values={tagOptions.filter((option) =>
                  selectedMandatoryTags.includes(option.label)
                )}
                onChangeValues={(values) =>
                  setSelectedMandatoryTags(values.map((option) => option.label))
                }
                containerStyle={{ margin: '0 0.5rem', marginBottom: '0.5rem' }}
              />
            </HintBox>

            <Select
              multiChoice={true}
              label={i18n.t('allTags', { ns: 'documentManager' })}
              options={tagOptions}
              values={tagOptions.filter((option) =>
                selectedAllTagsIDs.includes(option.value)
              )}
              onChangeValues={handleSelectAllTags}
              containerStyle={{ margin: '0 0.5rem', marginBottom: '0.5rem' }}
            />
            <Select
              multiChoice={true}
              label={i18n.t('optionalTags', { ns: 'documentManager' })}
              options={tagOptions}
              values={tagOptions.filter((option) =>
                selectedAtlestOneTagID.includes(option.value)
              )}
              onChangeValues={handleSelectAtleastOneTag}
              containerStyle={{ margin: '0 0.5rem' }}
            />

            {/*<div className="row">
              <div className="input-field col s12">
                <Select
                  label={i18n.t('searchType', { ns: 'documentManager' })}
                  options={searchOptions}
                  values={searchOptions.filter(
                    (option) => option.value.toString() === searchType
                  )}
                  onChangeValues={handleSearchOptions}
                  multiChoice={false}
                />
              </div>
            </div>*/}
            <div className="px-3 my-3">
              <Input
                type="checkbox"
                id="skipViewPermissionCheck"
                name="skipViewPermissionCheck"
                checked={skipViewPermissionCheck}
                label={i18n.t('skipViewPermissionCheck', {
                  ns: 'documentManager',
                })}
                onChange={(e) => setSkipViewPermissionCheck(e.target.checked)}
              />
              <Input
                type="checkbox"
                id="applyMyPermissionToItems"
                name="applyMyPermissionToItems"
                checked={applyMyPermissionToItems}
                label={i18n.t('applyMyPermissionToItems', {
                  ns: 'documentManager',
                })}
                onChange={(e) => setApplyMyPermissionToItems(e.target.checked)}
              />
            </div>
            <div className="row">
              <div className=" col s12">
                <Select
                  label={i18n.t('applyMinPermissionLevel', {
                    ns: 'documentManager',
                  })}
                  values={[
                    {
                      value: applyMinPermissionLevel || 'null',
                      label:
                        i18n.t(`${applyMinPermissionLevel}`, {
                          ns: 'documentManager',
                        }) || 'null',
                    },
                  ]}
                  options={[
                    {
                      value: 'null',
                      label: i18n.t('inactive', { ns: 'documentManager' }),
                    },
                    {
                      value: 'Report',
                      label: i18n.t('Report', { ns: 'documentManager' }),
                    },
                    {
                      value: 'ChangeData',
                      label: i18n.t('ChangeData', { ns: 'documentManager' }),
                    },
                  ]}
                  defaultValue={applyMinPermissionLevel}
                  onChangeValues={(values) => {
                    setApplyMinPermissionLevel(
                      values[0].value === 'null' ? null : values[0].value
                    );
                  }}
                  required={true}
                  allowRemove={false}
                />
              </div>
            </div>
            {!savingData ? (
              <span>
                <div className="row mx-3 my-2">
                  <span className="col s12">
                    <ErrorView className="red-text" err={null} />
                  </span>
                  <Button type={'submit'} color={'black-outline'}>
                    {i18n.t('save', { ns: 'documentManager' })}
                  </Button>
                </div>
              </span>
            ) : (
              <div className="row">
                <div className="col s12">
                  <div className="progress">
                    <div className="indeterminate" />
                  </div>
                </div>
              </div>
            )}
          </form>
        </span>
      </div>
    </div>
  );
};

SearchTagEditor.propTypes = {
  item: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  tags: PropTypes.object.isRequired,
};

export default SearchTagEditor;
